import React from 'react';
import { motion } from 'framer-motion';
const volumes = [{
  num: '1',
  title: 'Logica e Pensiero Computazionale',
  desc: 'I quattro pilastri del pensiero computazionale, logica booleana e primi algoritmi per le classi del biennio.'
}, {
  num: '2',
  title: 'Algoritmi e Pseudocodice',
  desc: 'Strutture di controllo, pseudocodice formale, algoritmi di ordinamento e introduzione alla notazione O-grande.'
}, {
  num: '3',
  title: 'Programmazione Base con Python',
  desc: 'Variabili, funzioni, cicli e gestione degli errori con progetto finale: il Registro Scolastico Digitale.'
}, {
  num: '4',
  title: 'Strutture Dati',
  desc: 'Liste, dizionari, set e tuple applicate a problemi reali con algoritmi implementati in Python.'
}, {
  num: '5',
  title: 'Sviluppo Web HTML5 e CSS3',
  desc: 'HTML5 semantico, Flexbox, Responsive Design e progetto finale: Sito Scolastico Completo.'
}, {
  num: '6',
  title: 'Progetti Interdisciplinari',
  desc: '5 progetti reali che integrano Python e HTML con connessioni a Matematica, Fisica e Italiano.'
}];
const sections = [{
  num: '02',
  title: 'Conforme MIUR',
  desc: 'Checklist Curriculum MIUR per monitorare il programma in 5 minuti a settimana. Non arriverai mai più in ritardo a fine anno.'
}, {
  num: '03',
  title: 'Pronto per LIM',
  desc: 'Slide interattive che trasformano codice e algoritmi in immagini logiche immediate. Apri, proietta e insegna.'
}, {
  num: '04',
  title: 'BES e DSA',
  desc: 'Schede semplificate con mappe concettuali per non lasciare indietro nessuno studente.'
}];
export function TomiSection() {
  return <section className="py-10 sm:py-12 px-4 bg-[#0d0d17] border-t border-brand-orange/10" data-id="element-256">
      <div className="max-w-xl mx-auto" data-id="element-257">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-258">
          <h2 className="text-2xl sm:text-3xl font-black text-brand-cream mb-3" data-id="element-259">
            Cosa include{' '}
            <span className="text-brand-orange" data-id="element-260">Programmazione Pronta.</span>
          </h2>
          <p className="text-sm text-gray-400 font-medium" data-id="element-261">
            Strumenti digitali in PDF pronti da stampare o proiettare da oggi
            stesso.
          </p>
        </motion.div>

        {/* Section 01 — Volumes */}
        <div className="mb-8" data-id="element-262">
          <div className="flex items-center gap-3 mb-5" data-id="element-263">
            <span className="text-brand-orange font-black text-sm tracking-widest" data-id="element-264">
              01
            </span>
            <span className="text-gray-600" data-id="element-265">|</span>
            <h3 className="text-base sm:text-lg font-black text-brand-cream uppercase" data-id="element-266">
              6 Volumi PDF — Il Percorso Completo
            </h3>
          </div>

          <div className="space-y-3" data-id="element-267">
            {volumes.map((v, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="bg-brand-card border border-white/10 p-4 rounded-xl" data-id="element-268">
                <div className="flex items-start gap-3" data-id="element-269">
                  <div className="bg-brand-orange text-white text-xs font-black px-2.5 py-1 rounded shrink-0" data-id="element-270">
                    VOL {v.num}
                  </div>
                  <div data-id="element-271">
                    <h4 className="font-bold text-brand-cream text-sm sm:text-base mb-1" data-id="element-272">
                      {v.title}
                    </h4>
                    <p className="text-xs sm:text-sm text-gray-400 leading-snug" data-id="element-273">
                      {v.desc}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* Sections 02-04 */}
        <div className="space-y-4 mb-8" data-id="element-274">
          {sections.map((s, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-card border border-brand-orange/20 p-5 rounded-2xl" data-id="element-275">
              <div className="flex items-center gap-3 mb-2" data-id="element-276">
                <span className="text-brand-orange font-black text-sm tracking-widest" data-id="element-277">
                  {s.num}
                </span>
                <span className="text-gray-600" data-id="element-278">|</span>
                <h3 className="text-base font-black text-brand-cream uppercase" data-id="element-279">
                  {s.title}
                </h3>
              </div>
              <p className="text-sm text-gray-400 leading-snug" data-id="element-280">{s.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}